module.exports = __webpack_public_path__ + "img/logo-text-black.47d15d1e.png";